import React from 'react';
import { Link } from 'react-router-dom';
import './Signup.css';

const Signup = () => {
  const emailValue = React.useRef(null);
  const passwordValue = React.useRef(null);
  const firstNameValue = React.useRef(null);
  const lastNameValue = React.useRef(null);
  const maleGenderValue = React.useRef(null);
  const femaleGenderValue = React.useRef(null);
  const dateOfBirthValue = React.useRef(null);
  const agreementValue = React.useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      email: emailValue.current.value,
      password: passwordValue.current.value,
      firstname: firstNameValue.current.value,
      lastname: lastNameValue.current.value,
      male: maleGenderValue.current.value,
      female: femaleGenderValue.current.value,
      dob: dateOfBirthValue.current.value,
      agreement: agreementValue.current.value,
    };

    return data;
  };

  return (
    <>
      <section className="register-section">
        <div className="register-container">
          <h2 className="auth-title">
            Lets help you make your collaborations easy.
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="register_names">
              <label htmlFor="Firstname">
                First name <br />
                <input
                  type="name"
                  name="firstname"
                  className="register_fname"
                  required="required"
                  ref={firstNameValue}
                />
              </label>

              <label htmlFor="Lastname">
                Last name <br />
                <input
                  type="name"
                  name="lastname"
                  className="register_lname"
                  required="required"
                  ref={lastNameValue}
                />
              </label>
            </div>

            <label htmlFor="email">
              Email <br />
              <input
                type="email"
                name="email"
                className="register_email"
                required="required"
                ref={emailValue}
              />
            </label>

            <label htmlFor="password">
              Password <br />
              <input
                type="password"
                name="password"
                className="register_pswd"
                required="required"
                ref={passwordValue}
              />
            </label>

            <div className="register_dob_container">
              <h2>Date of Birth</h2>

              <div className="register_dob">
                <label htmlFor="day">
                  <input
                    type="number"
                    name="day"
                    pattern="[0-9]*"
                    maxLength="2"
                    size="2"
                    className="dob_day"
                    required="required"
                    ref={dateOfBirthValue}
                    placeholder="00"
                  />
                </label>
              </div>

              <div className="register_dob">
                <label htmlFor="month">
                  <input
                    type="number"
                    pattern="[0-9]*"
                    maxLength="2"
                    size="2"
                    className="dob_month"
                    required="required"
                    ref={dateOfBirthValue}
                    placeholder="00"
                  />
                </label>
              </div>

              <div className="register_dob">
                <label htmlFor="year">
                  <input
                    type="number"
                    pattern="[0-9]*"
                    maxLength="4"
                    size="4"
                    className="dob_year"
                    required="required"
                    placeholder="00"
                    ref={dateOfBirthValue}
                  />
                </label>
              </div>
            </div>

            <div className="register_gender">
              <h2>Gender</h2>
              <label htmlFor="gender">
                <input
                  type="radio"
                  name="gender"
                  className="r__gender"
                  value="female"
                  ref={femaleGenderValue}
                />
                Female
              </label>

              <label htmlFor="gender">
                <input
                  type="radio"
                  name="gender"
                  className="r__gender"
                  value="male"
                  ref={maleGenderValue}
                />
                Male
              </label>
            </div>

            <label htmlFor="agreement">
              <input type="checkbox" name="remember" ref={agreementValue} />
              By clicking Sign up, you agree to{' '}
              <Link to="/terms">our terms</Link>, data policy and cookie policy,
              You will rececieve an email asking you to verify your email.
            </label>

            <input type="submit" value="Sign up" className="btn" />
          </form>
        </div>
      </section>
    </>
  );
};

export default Signup;
